import { ZoomInMap } from '@mui/icons-material'
import { Button, ButtonGroup, Stack } from '@mui/material'
import { FC, useState } from 'react'
import { MinusIcon, PlusIcon } from '../../icons'

type Props = {
  disabled?: boolean
  zoomLevel?: number
  minZoomLevel?: number
  maxZoomLevel?: number
  steps?: number
  onZoomIn?: (zoomLevel: number) => void
  onZoomOut?: (zoomLevel: number) => void
  onResetZoom?: (zoomLevel: number) => void
}

export const ZoomControl: FC<Props> = props => {
  const {
    disabled,
    zoomLevel = 1,
    minZoomLevel = 0.5,
    maxZoomLevel = 2,
    steps = 0.1,
    onZoomIn,
    onZoomOut,
    onResetZoom,
  } = props

  const [currentZoomLevel, setCurrentZoomLevel] = useState(zoomLevel)

  const increaseZoom = () => {
    if (onZoomIn) {
      const newZoomLevel = Math.min(currentZoomLevel + steps, maxZoomLevel)
      setCurrentZoomLevel(newZoomLevel)
      onZoomIn(newZoomLevel)
    }
  }

  const decreaseZoom = () => {
    if (onZoomOut) {
      const newZoomLevel = Math.max(currentZoomLevel - steps, minZoomLevel)
      setCurrentZoomLevel(newZoomLevel)
      onZoomOut(newZoomLevel)
    }
  }

  const resetZoom = () => {
    if (onResetZoom) {
      setCurrentZoomLevel(zoomLevel)
      onResetZoom(zoomLevel)
    }
  }

  return (
    <Stack>
      <ButtonGroup variant='outlined' color='secondary' sx={{ backgroundColor: 'white' }}>
        <Button disabled={disabled || zoomLevel <= minZoomLevel} onClick={decreaseZoom}>
          <MinusIcon fontSize='small' />
        </Button>
        <Button disabled={disabled || zoomLevel >= maxZoomLevel} onClick={increaseZoom}>
          <PlusIcon fontSize='small' />
        </Button>
        <Button disabled={disabled} onClick={resetZoom}>
          <ZoomInMap fontSize='small' />
        </Button>
      </ButtonGroup>
    </Stack>
  )
}
